<template>
  <main class="main page-inside">
    <div class="main-wrapper">
      <section class="section product-list-section">
        <div class="wrapper">

          <!-- <div class="title">
            {{ $t(`Store`) }}
          </div> -->

          <div class="filters-container">
            <div class="filters-text">{{ $t(`Filters`) }}</div>

            <!-- Price Filter -->
            <div class="filter-dropdown price-filter" ref="priceDropdownRef"
              @click="toggleDropdown('priceListIsVisible')">
              <span>Price {{ barMinValue }} - {{ barMaxValue }}</span>

              <img src="@/assets/img/arrow-down.svg" :class="{ 'rotated': priceListIsVisible }" alt="arrow" />
              <div v-if="priceListIsVisible" class="dropdown-menu price-dropdown" @click="stopPropagation">
                <div class="price-input-container">
                  <label class="price-label">
                    <span class="min">{{ $t(`Min:`) }}</span>
                    <input type="number" :value="tempMinValue" class="price-input" placeholder="0"
                      @input="updateTempMinValue" />
                  </label>
                  <input type="range" :value="tempMinValue" :min="0" :max="9999" @input="updateTempMinValueRange" />
                  <label class="price-label">
                    <span class="max">{{ $t(`Max:`) }}</span>
                    <input type="number" :value="tempMaxValue" class="price-input" placeholder="9999"
                      @input="updateTempMaxValue" />
                  </label>
                  <input type="range" :value="tempMaxValue" :min="0" :max="9999" @input="updateTempMaxValueRange" />
                </div>
              </div>
            </div>

            <!-- Type Filter -->
            <div class="filter-dropdown type-filter" ref="typeDropdownRef" @click="toggleDropdown('typeListIsVisible')">
              <div>
                <!-- <div class="filter-label">{{ $t(`Type`) }}</div> -->
                <div class="filter-value">
                  {{ category ? category : 'All types' }}
                </div>
              </div>
              <img src="@/assets/img/arrow-down.svg" :class="{ 'rotated': typeListIsVisible }" alt="arrow" />
              <div v-if="typeListIsVisible" class="dropdown-menu" @click="stopPropagation">
                <label v-for="(item) in categoryOptions" :key="item" class="checkbox-label">
                  <div class="checkbox-label-wrapper">
                    <input type="radio" :value="item" v-model="category" />
                    <div class="checkbox"></div>
                    <span class="desc">{{ item }}</span>
                  </div>
                </label>
              </div>
            </div>

            <!-- Quality Filter -->
            <!-- <div class="filter-dropdown quality-filter" ref="qualityDropdownRef"
              @click="toggleDropdown('qualityListIsVisible')">
              <div>
                <div class="filter-label">{{ $t(`Quality`) }}</div>
                <div class="filter-value">{{ quality ? quality : 'All quality' }}</div>
              </div>
              <img src="@/assets/img/arrow-down.svg" :class="{ 'rotated': qualityListIsVisible }" alt="arrow" />
              <div v-if="qualityListIsVisible" class="dropdown-menu" @click="stopPropagation">
                <label v-for="(item) in qualityOptions" :key="item" class="checkbox-label">
                  <div class="checkbox-label-wrapper">
                    <input type="radio" :value="item" v-model="quality" />
                    <div class="checkbox"></div>
                    <span class="desc">{{ item }}</span>
                  </div>
                </label>
              </div>
            </div> -->

            <!-- Sort -->
            <div class="sort-container">
              <span class="sort-text">{{ $t(`Sort:`) }}</span>
              <div class="filter-dropdown sort-dropdown" ref="sortDropdownRef"
                @click="toggleDropdown('sortListIsVisible')">
                <div>
                  <!-- <div class="filter-label">{{ $t(`Sort by`) }}</div> -->
                  <div class="filter-value">{{ sort === 'desc' ? $t("Highest price first") : $t("Lowest price first") }}</div>
                </div>
                <img src="@/assets/img/arrow-down.svg" :class="{ 'rotated': sortListIsVisible }" alt="arrow" />
                <div v-if="sortListIsVisible" class="dropdown-menu" @click="stopPropagation">
                  <label class="checkbox-label">
                    <div class="checkbox-label-wrapper">
                      <input type="radio" name="desc" value="desc" v-model="sort" />
                      <div class="checkbox"></div>
                      <span class="desc">{{ $t("Highest price first") }}</span>
                    </div>
                  </label>
                  <label class="checkbox-label">
                    <div class="checkbox-label-wrapper">
                      <input type="radio" name="asc" value="asc" v-model="sort" />
                      <div class="checkbox"></div>
                      <span class="desc">{{ $t("Lowest price first") }}</span>
                    </div>
                  </label>
                </div>
              </div>
            </div>
          </div>

          <div :class="['products-container', { active: !filtersIsVisible }]">
            <Transition>
              <div class="list products" v-if="productList && productList.length">
                <div class="item" v-for="(item, i) in productList" :key="i">
                  <ProductCard :item="item" :currencySymbol="currencySymbol" @goToProduct="goToProduct" />
                </div>
              </div>

              <!-- <div v-else-if="isFetchingProducts" class="loading-products">
                <p>{{ $t("Loading products...") }}</p>
              </div> -->
            </Transition>

            <div v-if="(!productList || !productList.length) && !isFetchingProducts" class="no-products">
              <p>{{ $t("No products found") }}</p>
              <button class="button primary" @click="resetFilters">{{ $t("Reset filters") }}</button>
            </div>

          </div>

          <Pagination v-if="totalProducts" :total-pages="totalPages" v-model:per-page="perPage"
            v-model:current-page="activePage" @update:per-page="updatePerPage" @update:current-page="changePage" />
        </div>
      </section>
    </div>
  </main>
</template>
<script>
import ProductCard from "../components/ProductCard.vue";
import Pagination from '../components/PaginationComponent.vue';
import { mapActions, mapGetters } from "vuex";
export default {
  name: "ProductListPage",
  props: {
    currencyCode: {
      type: String,
      required: true
    },
    currencySymbol: {
      type: String,
      required: true
    },
  },
  components: {
    Pagination,
    ProductCard,
  },
  data: function () {
    return {
      imgDomain: "",
      filtersIsVisible: true,
      sort: "desc",
      totalProducts: null,
      totalPages: 1,
      perPage: 20,
      activePage: 1,
      
      barMinValue: 0,
      barMaxValue: 9999,
      tempMinValue: 0, // Temporary value for debouncing
      tempMaxValue: 9999, // Temporary value for debouncing
      productList: [],
      priceListIsVisible: false,
      typeListIsVisible: false,
      qualityListIsVisible: false,
      sortListIsVisible: false,
      
      // Track loading states
      isLoading: true,
      isFetchingProducts: false,
      
      // Flag to track our own URL changes
      isOurOwnNavigation: false,
      
      // Debounce timers
      priceDebounceTimer: null,
      
      // Maintain compatibility with existing template
      category: "All types",
      quality: "All quality",
      categoryOptions: [],
      qualityOptions: [],
      specialCategory: "",
      
      // API request controller for cancelling in-flight requests
      currentRequest: null,
      
      // For handling UI click outside events
      priceDropdownRef: null,
      typeDropdownRef: null,
      qualityDropdownRef: null,
      sortDropdownRef: null,
      
      filters: {
        types: {
          options: [],
          selected: 'all',
          visible: true,
          apiParam: 'type',
          excludeFromCategory: true
        },
        qualities: {
          options: [],
          selected: 'all',
          visible: false,
          apiParam: 'quality'
        },
        heroes: {
          options: [],
          selected: 'all',
          visible: false,
          apiParam: 'hero'
        },
        exterior_names: {
          options: [],
          selected: 'all',
          visible: false,
          apiParam: 'exterior_name'
        },
        classes: {
          options: [],
          selected: 'all',
          visible: false,
          apiParam: 'item_class'
        }
      },
    };
  },
  computed: {
    ...mapGetters("app", ["isAuth"]),
    
    // Create a computed property for the current category from route
    currentCategory() {
      return this.$route.params.type || '';
    },
    
    // Get all active filter values for API request
    activeFilters() {
      const result = {};
      
      // Add all selected filters
      for (const [, filter] of Object.entries(this.filters)) {
        if (filter.selected && filter.selected !== 'all') {
          result[filter.apiParam] = filter.selected;
        }
      }
      
      // Add price range and sort
      result.price_from = this.barMinValue;
      result.price_till = this.barMaxValue;
      result.sort = this.sort;
      
      return result;
    }
  },
  watch: {
    // Watch for direct route changes (URL navigation)
    '$route': {
      immediate: true,
      handler(to, from) {
        // Skip if this is a URL change we triggered ourselves
        if (this.isOurOwnNavigation) {
          this.isOurOwnNavigation = false;
          return;
        }
        
        // Initial component load or complete URL change, sync from URL
        if (!from || to.path !== from.path) {
          // Ensure we capture the new category parameter
          if (to.params.type === "revolution-collection") {
            this.specialCategory = to.params.type;
          } else if (to.params.type && to.params.type != 'all') {
            this.specialCategory = to.params.type;
          } else {
            this.specialCategory = "";
          }
          
          this.syncFromUrl();
          return;
        }
        
        // If only the query params changed (and not by our own actions)
        // First check if any filter param changed
        const hasFilterChanged = this.hasFilterParamChanged(to.query, from.query);
        if (hasFilterChanged) {
          // Any filter change resets to page 1
          this.syncFromUrl(true); // true means force page 1
          return;
        }
        
        // If only page changed
        if (to.query.page !== from.query.page) {
          this.activePage = parseInt(to.query.page) || 1;
          this.fetchProducts();
        }
      }
    },
    
    // Any filter change should update URL and reset to page 1
    activeFilters: {
      deep: true,
      handler() {
        if (!this.isLoading) {
          this.updateUrl(true); // true means reset to page 1
        }
      }
    },
    
    // Watch for category changes to reset filters
    currentCategory(newCategory, oldCategory) {
      if (newCategory !== oldCategory) {
        this.resetFilters();
        this.fetchFilterOptions(newCategory);
      }
    },
    
    // For compatibility with existing template
    category() {
      if (!this.isLoading) {
        this.activePage = 1;
        this.filters.types.selected = this.category !== "All types" ? this.category.toLowerCase() : 'all';
      }
    },
    
    quality() {
      if (!this.isLoading) {
        this.activePage = 1;
        this.filters.qualities.selected = this.quality !== "All quality" ? this.quality.toLowerCase() : 'all';
      }
    }
  },
  
  mounted() {
    // Initial setup - fetch filter options for current category
    if (this.$route.params.type === "revolution-collection") {
      this.specialCategory = this.$route.params.type;
    } else if (this.$route.params.type && this.$route.params.type != 'all') {
      this.specialCategory = this.$route.params.type;
    }
    
    this.fetchFilterOptions(this.currentCategory);
    
    // Set state from URL on initial load
    this.syncFromUrl();
    
    // Fetch discount info if needed
    if (this.isAuth) {
      this.fetchActiveDiscount(this.currencyCode);
    }
    
    // Setup click outside handlers from the original template
    if (this.$refs.priceDropdownRef) {
      const { onClickOutside } = require('@vueuse/core');
      onClickOutside(this.$refs.priceDropdownRef, () => this.priceListIsVisible = false);
      onClickOutside(this.$refs.typeDropdownRef, () => this.typeListIsVisible = false);
      onClickOutside(this.$refs.qualityDropdownRef, () => this.qualityListIsVisible = false);
      onClickOutside(this.$refs.sortDropdownRef, () => this.sortListIsVisible = false);
    }
  },
  
  methods: {
    ...mapActions('discount', ['fetchActiveDiscount']),
    
    // Synchronize component state from URL
    syncFromUrl(resetPage = false) {
      this.isLoading = true;
      const query = this.$route.query;
      
      // Update sort
      this.sort = query.sort || 'desc';
      
      // Update price range
      this.barMinValue = parseInt(query.price_from) || 0;
      this.barMaxValue = parseInt(query.price_till) || 9999;
      
      // Also update the temporary values
      this.tempMinValue = this.barMinValue;
      this.tempMaxValue = this.barMaxValue;
      
      // Update page (reset to 1 if filter changed or resetPage is true)
      this.activePage = resetPage ? 1 : (parseInt(query.page) || 1);
      
      // Update all filters from URL
      for (const [, filter] of Object.entries(this.filters)) {
        const value = query[filter.apiParam];
        filter.selected = value || 'all';
      }
      
      // Update category and quality for UI dropdown compatibility
      if (this.filters.types.selected !== 'all') {
        this.category = this.filters.types.selected;
      } else {
        this.category = "All types";
      }
      
      if (this.filters.qualities.selected !== 'all') {
        this.quality = this.filters.qualities.selected;
      } else {
        this.quality = "All quality";
      }
      
      // Fetch products with current state
      this.fetchProducts();
      this.isLoading = false;
    },
    
    // Update URL with current state
    updateUrl(resetPage = false) {
      // Skip URL updates during initialization
      if (this.isLoading) return;
      
      // If page was reset, update activePage first
      if (resetPage) {
        this.activePage = 1;
      }
      
      // Build query object with current state
      const query = {
        sort: this.sort,
        price_from: this.barMinValue,
        price_till: this.barMaxValue,
        page: this.activePage
      };
      
      // Add all active filters
      for (const [, filter] of Object.entries(this.filters)) {
        if (filter.selected && filter.selected !== 'all') {
          query[filter.apiParam] = filter.selected;
        }
      }
      
      // Set flag to indicate this is our own navigation action
      this.isOurOwnNavigation = true;
      
      // First fetch products with the correct state
      this.fetchProducts();
      
      // Then update URL - use push to add to browser history
      this.$router.push({ query }).catch(() => {});
    },
    
    // Fetch products based on current state
    fetchProducts() {
      this.isFetchingProducts = true;
      
      // If a request is in progress, cancel it
      if (this.currentRequest) {
        this.currentRequest.abort();
        this.currentRequest = null;
      }
      
      // Create new abort controller
      this.currentRequest = new AbortController();
      const signal = this.currentRequest.signal;
      
      // Build params - use component state directly, don't read from URL
      let params = new URLSearchParams();
      
      // Add category if applicable - only for specific supported categories
      if (this.specialCategory && ['cs2', 'tf2'].includes(this.specialCategory)) {
        params.append('category', this.specialCategory);
      }
      
      // Add all selected filters
      for (const [, filter] of Object.entries(this.filters)) {
        if (filter.selected && !filter.selected.startsWith('all')) {
          params.append(filter.apiParam, filter.selected);
        }
      }
      
      // Add price range and sort
      params.append('price_from', this.barMinValue);
      params.append('price_till', this.barMaxValue);
      params.append('sort', this.sort);
      
      // Add pagination
      params.append('page', this.activePage);
      params.append('limit', this.perPage);
      
      // Add currency if needed
      if (this.currencyCode) {
        params.append('currency', this.currencyCode);
      }
      
      // Make the request
      this.$http.get(`${process.env.VUE_APP_API}items/list?${params}`, { signal })
        .then((res) => {
          this.productList = res.data.payload;
          this.totalProducts = res.data.meta.total;
          this.totalPages = res.data.meta.pages;
        })
        .catch((error) => {
          // Don't handle abort errors
          if (error.name === 'AbortError') return;
          
          if (error.response?.status === 401) {
            this.$parent.openSignInModal();
          }
        })
        .finally(() => {
          this.isFetchingProducts = false;
          this.currentRequest = null;
        });
    },
    
    // Fetch filter options for a category
    fetchFilterOptions(category) {
      // Reset filter options first
      for (const key in this.filters) {
        this.filters[key].options = ['all'];
      }
      
      // Only add category parameter for supported categories
      let apiUrl = `${process.env.VUE_APP_API}items/filter-data`;
      if (category && ['cs2', 'tf2'].includes(category)) {
        apiUrl += `?category=${category}`;
      }
      
      this.$http.get(apiUrl)
        .then((res) => {
          const data = res.data.payload;
          
          // Populate filter options
          for (const [key, options] of Object.entries(data)) {
            if (this.filters[key]) {
              if (this.filters[key].excludeFromCategory && ['cs2', 'tf2'].includes(options)) {
                continue;
              }
              this.filters[key].options = ['all', ...options.map(option => option.toLowerCase())];
            }
          }
          
          // Update categoryOptions and qualityOptions arrays for dropdown UI
          if (data.types) {
            let types = ['All types', ...data.types.map(option => option.toLowerCase())];
            this.categoryOptions = types;
          }
          
          if (data.qualities) {
            let qualities = ['All quality', ...data.qualities.map(option => option.toLowerCase())];
            this.qualityOptions = qualities;
          }
        })
        .catch((error) => {
          if (error.response?.status === 401) {
            this.$parent.openSignInModal();
          }
        });
    },
    
    // Check if any filter parameter changed between two query objects
    hasFilterParamChanged(newQuery, oldQuery) {
      const filterParams = ['sort', 'price_from', 'price_till'];
      
      // Check standard filter params
      for (const param of filterParams) {
        if (newQuery[param] !== oldQuery[param]) {
          return true;
        }
      }
      
      // Check filter-specific params
      for (const [, filter] of Object.entries(this.filters)) {
        if (filter.apiParam && newQuery[filter.apiParam] !== oldQuery[filter.apiParam]) {
          return true;
        }
      }
      
      return false;
    },
    
    // Reset all filters to defaults
    resetFilters() {
      // Reset all filter values
      this.sort = 'desc';
      this.barMinValue = 0;
      this.barMaxValue = 9999;
      this.activePage = 1; // Explicitly set page to 1
      this.category = "All types";
      this.quality = "All quality";
      
      for (const filter of Object.values(this.filters)) {
        filter.selected = 'all';
      }
      
      // Set flag to indicate this is our own navigation action
      this.isOurOwnNavigation = true;
      
      // First fetch products with the reset state
      this.fetchProducts();
      
      // Then update URL with empty query params
      this.$router.push({ query: {} }).catch(() => {});
    },
    
    // Toggle filter visibility
    toggleFilterVisibility(filterName) {
      this.filters[filterName].visible = !this.filters[filterName].visible;
    },
    
    // For compatibility with existing template
    toggleDropdown(dropdown) {
      this[dropdown] = !this[dropdown];
      ['priceListIsVisible', 'typeListIsVisible', 'qualityListIsVisible', 'sortListIsVisible'].forEach(key => {
        if (key !== dropdown) {
          this[key] = false;
        }
      });
    },
    
    stopPropagation(event) {
      event.stopPropagation();
    },
    
    // Update temporary values and debounce real update
    updateTempMinValue(event) {
      const newValue = Number(event.target.value);
      this.tempMinValue = Math.min(newValue, this.tempMaxValue);
      this.debouncePriceChange();
    },
    
    updateTempMaxValue(event) {
      const newValue = Number(event.target.value);
      this.tempMaxValue = Math.max(newValue, this.tempMinValue);
      this.debouncePriceChange();
    },
    
    // For range inputs
    updateTempMinValueRange(event) {
      const newValue = Number(event.target.value);
      this.tempMinValue = Math.min(newValue, this.tempMaxValue);
      this.debouncePriceChange();
    },
    
    updateTempMaxValueRange(event) {
      const newValue = Number(event.target.value);
      this.tempMaxValue = Math.max(newValue, this.tempMinValue);
      this.debouncePriceChange();
    },
    
    // Debounce price changes to prevent excessive API calls
    debouncePriceChange() {
      clearTimeout(this.priceDebounceTimer);
      this.priceDebounceTimer = setTimeout(() => {
        if (!this.isLoading) {
          // Apply the temporary values to the actual model values
          this.barMinValue = this.tempMinValue;
          this.barMaxValue = this.tempMaxValue;
          // Only then update the URL and trigger API call
          this.updateUrl(true);
        }
      }, 350);
    },
    
    // Format filter name for display
    formatFilterName(name) {
      return name.split('_').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');
    },
    
    // Handle page change from pagination component
    changePage(page) {
      this.activePage = page;
      this.updateUrl();
    },
    
    // Handle per page change
    updatePerPage(newPerPage) {
      this.perPage = newPerPage;
      this.activePage = 1;
      this.updateUrl();
    },
    
    // Handle item click navigation
    goToProduct(item) {
      this.$emit("goToProduct", item);
    },
    
    // Handle add to cart
    addToCart(item, id, item_type) {
      this.$emit("addToCart", item, id, item_type);
    },
    
    // Toggle mobile filter visibility
    openFilter() {
      this.filtersIsVisible = !this.filtersIsVisible;
    }
  },
};
</script>
<style scoped lang="scss">
.product-list-section {
  margin-top: 20px;
}

.product-list-section .title {
  margin-bottom: 40px;
}

.filters-container {
  width: 100%;
  color: white;
  display: flex;
  align-items: center;
}

.filters-text,
.sort-text {
  font-size: 20px;
  font-weight: 700;
  line-height: 27px;
  text-align: left;
  margin-right: 16px;
}

.filter-dropdown {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 20px;
  border-radius: 8px;
  border: 1px solid #46566A;
  background: #516182;

  cursor: pointer;
  margin-right: 16px;
  max-width: 234px;
  width: 100%;
  height: 56px;
  position: relative;

  &.price-filter {
    color: #fff;
  }

  &.sort-dropdown {
    margin-right: 0;
  }

  .filter-label {
    font-size: 12px;
    font-weight: 400;
    line-height: 16px;
    text-align: left;
    color: #fff;
  }

  .filter-value {
    font-size: 16px;
    font-weight: 400;
    line-height: 24px;
    text-transform: lowercase;

    &::first-letter {
      text-transform: uppercase;
    }
  }

  img {
    width: 24px;
    height: 24px;
    transition: transform 0.3s ease;

    &.rotated {
      transform: rotate(180deg);
    }
  }

  .dropdown-menu {
    position: absolute;
    top: 60px;
    left: 0;
    background-color: #516182;
    padding: 16px;
    border: 1px solid #46566A;
    border-radius: 8px;
    width: 100%;
    max-height: 300px;
    overflow-y: auto;
    z-index: 10;
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  .price-dropdown {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
  }

  .price-input-container {
    display: flex;
    flex-direction: column;
    gap: 10px;

    width: 100%;
    margin-bottom: 8px;

    .price-label {
      display: flex;
      flex-wrap: nowrap;
      justify-content: center;
      justify-content: flex-start;
      align-items: center;
      gap: 10px;
    }

    .price-label .min,
    .price-label .max {
      width: 40px;
      display: inline-block;
    }

  }

  .price-input {
    width: 100%;
    padding: 8px;
    border: 1px solid #46566A;
    border-radius: 8px;
    background-color: #3A3F56;
    color: white;
  }

  input[type="range"] {
    width: 100%;
    padding: 0;
    margin-top: 8px;
    background: inherit;
  }
}

.sort-container {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  width: 100%;
}

.no-products,
.loading-products {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 20px;
  width: 100%;
  height: 282px;
  color: white;
  font-size: 20px;
  font-weight: 700;
  line-height: 24px;
  text-align: center;
}

@media (max-width: 1200px) {
  .filters-container {
    flex-wrap: wrap;
  }

  .filters-text,
  .sort-text {
    align-self: flex-start;
    margin-bottom: 16px;
  }

  .sort-container {
    flex-direction: column;
  }

  .filter-dropdown,
  .sort-container {
    margin-bottom: 16px;
    width: 100%;
    min-width: 100%;
  }

  // .products-container {
  //   max-height: 543px;
  //   overflow-y: auto;
  // }
}
</style>